enum ReviewTextType {
	POSITIVE = 'POSITIVE',
	NEGATIVE = 'NEGATIVE',
	GENERAL = 'GENERAL',
	TITLE = 'TITLE',
}

export default ReviewTextType;